import React from 'react';
import type { ReactNode } from 'react';
import { ClientViewProvider } from './contexts/ClientViewContext';
import { PortalAuthProvider } from './auth';

interface PortalProvidersProps {
  children: ReactNode;
}

/**
 * PortalProviders
 *
 * Ensures portal modules share a single source of truth for Client View state.
 * IMPORTANT: ClientViewProvider must wrap PortalAuthProvider so the auth bridge
 * can react to enter/exit of admin client-view sessions.
 */
export const PortalProviders: React.FC<PortalProvidersProps> = ({ children }) => {
  return (
    <ClientViewProvider>
      <PortalAuthProvider>{children}</PortalAuthProvider>
    </ClientViewProvider>
  );
};

export default PortalProviders;
